export const IN_LISTING_BANNERS_IDENTIFIER = 'inlisting-banner';
